<template>
  <div class="flex flex-row justify-center gap-4 lg:mr-10 lg:pr-10">
    <a href="https://twitter.com/AlegraWeb" target="_blank">
      <img class="icon" src="../assets/Social_Network/icons8-twitter.svg" alt="twitter Icon" />
    </a>
    <a :href="$transF('SocialNetworks.Facebook')" target="_blank">
      <img class="icon" src="../assets/Social_Network/icons8-facebook-f.svg" alt="facebook Icon" />
    </a>
    <a :href="$transF('SocialNetworks.Linkedin')" target="_blank">
      <img class="icon" src="../assets/Social_Network/icons8-linkedin-24.svg" alt="linkedin Icon" />
    </a>
    <a :href="$transF('SocialNetworks.Youtube')" target="_blank">
      <img class="icon" src="../assets/Social_Network/icons8-youtube.svg" alt="youtube Icon" />
    </a>
    <a :href="instagramUrl" target="_blank">
      <img class="icon" src="../assets/Social_Network/icons8-instagram.svg" alt="Tiktok Icon" />
    </a>
    <a class="tiktok" :href="$transF('SocialNetworks.Tiktok')" target="_blank">
      <img class="icon" src="../assets/Social_Network/tiktok-svgrepo-com.svg" alt="Tiktok Icon" />
    </a>
  </div>
</template>

<script setup lang="ts">
import { $transF } from 'app_alegra_commons/translate'
import { computed } from 'vue'
import { useAppStore } from 'app_alegra_commons/app'

const APP = useAppStore()

const instagramUrl = computed(() => {
  switch (APP.appVersion) {
    case 'mexico':
      return 'https://www.instagram.com/alegramexico'

    case 'republicaDominicana':
      return 'https://www.instagram.com/alegrard'

    case 'peru':
      return 'https://www.instagram.com/alegraper'

    case 'panama':
      return 'https://www.instagram.com/alegrapa'

    case 'spain':
      return 'https://www.instagram.com/alegraesp'
    case 'costaRica':
      return 'https://www.instagram.com/alegracri?igsh=MThhY283eXptd3Q4MA=='
    default:
      return 'https://www.instagram.com/alegraweb'
  }
})
</script>

<style lang="scss" scoped>
a {
  @apply p-2;
}

.icon {
  @apply w-7 h-7;
}
</style>
